const colors = [
    {
        display: "white",
        color: "white"
    },
    {
        display: "pink",
        color: "pink"
    },
    {
        display: "black",
        color: "black"
    },
    {
        display: "yellow",
        color: "yellow"
    },
    {
        display: "orange",
        color: "orange"
    },
    {
        display: "blue",
        color: "blue"
    }
]

export default colors